// src/data/contractData.js

export const categories = [
    "Custom Software Development",
    "Software as a Service (SaaS)",
    "Software Maintenance and Support",
    "Software Licensing",
    "Intellectual Property Licensing",
    "IT Consulting",
    "IT Outsourcing",
    "Infrastructure as a Service (IaaS)",
    "Platform as a Service (PaaS)",
    "Hardware Maintenance and Support",
    "Service Level Agreements (SLAs)",
    "Collaborative R&D",
    "Technical Support",
    "Joint Ventures",
  ];
  
  export const paymentTerms = [
    "Net 30",
    "Net 60",
    "Net 90",
    "Cash on Delivery (COD)",
    "Due on Receipt",
    "End of Month (EOM)",
    "2/10 Net 30",
    "50/50",
    "Milestone Payments",
    "Progress Payments",
    "Retainage",
    "Advance Payment",
    "Deferred Payment",
    "Installment Payments",
    "Prepaid",
    "Quartely",
    "Annually",
    "Letter of Credit",
    "Bank Guarantee",
    "Payment on Completion"
  ];
  